export const locales = {
  en: {
    tagline1: 'Deep focus, deep calm.',
    tagline2: 'A mindful space for uninterrupted work.',
    tagline3: 'Choose your scene, set your intention, and begin.',
    beginSession: 'Begin your session',
    clickAnywhere: 'Click anywhere to explore',
    history: 'History',
    buyCoffee: 'Buy me a coffee',
    openingKofi: 'Opening Ko-fi...',
    back: 'Back',
    chooseScene: 'Choose your scene',
    sceneDesc: 'Select an environment for your focus session',
    continueWith: 'Continue with {{name}}',
    parallax: 'Parallax',
    photographic: 'photographic',
    adjust: 'adjust',
    modeSolid: 'solid',
    modeScene: 'scene',
    sessionLength: 'Session length',
    start: 'Start',
    pause: 'Pause',
    reset: 'Reset',
    newSession: 'New session',
    sessionComplete: 'Session complete',
    duration: 'Duration',
    scene: 'Scene',
    date: 'Date',
    intention: 'Intention',
    intentionPlaceholder: 'What do you want to focus on?',
    close: 'Close',
    copySummary: 'Copy summary',
    copied: 'Copied',
    exitFullscreen: 'Press {{key}} to exit full-screen mode',
    imageAdjustments: 'Image adjustments',
    brightness: 'Brightness',
    blur: 'Blur',
    selectSceneImage: 'Select a scene image',
    pickerDesc: 'Choose a built-in sample or upload your own photo.',
    rename: 'Rename',
    delete: 'Delete',
    renamePhoto: 'Rename photo',
    photoName: 'Photo name',
    cancel: 'Cancel',
    save: 'Save',
    moreActions: 'More actions',
    custom: 'Custom',
    customBadge: 'Custom',
    uploadImage: 'Upload image',
    sessionHistory: 'Session History',
    dayStreak: 'day streak',
    sessions: 'sessions',
    totalMin: 'total min',
    noSessions: 'No sessions yet.\nComplete a focus session to see it here.',
    clearHistory: 'Clear history',
    confirmClear: 'Clear all session history?',
    shotBy: 'shot by {{author}}',
    focusedOn: 'Focus Session — {{date}}',
  },
  zh: {
    name: '中文',
    deepStill: 'Deep Still',
    tagline1: '深度专注，深层宁静。',
    tagline2: '一个不受打扰的正念空间。',
    tagline3: '选择场景，设定意图，开始专注。',
    beginSession: '开始专注',
    clickAnywhere: '点击任意处探索',
    history: '历史',
    buyCoffee: '请我喝咖啡',
    openingKofi: '正在打开 Ko-fi...',
    back: '返回',
    chooseScene: '选择场景',
    sceneDesc: '为你的专注时间选择一个环境',
    continueWith: '使用 {{name}} 继续',
    parallax: '视差',
    photographic: '摄影',
    adjust: '调整',
    sessionLength: '专注时长',
    start: '开始',
    pause: '暂停',
    reset: '重置',
    newSession: '新的专注',
    sessionComplete: '专注完成',
    duration: '时长',
    scene: '场景',
    date: '日期',
    intention: '意图',
    intentionPlaceholder: '你想专注于什么？',
    close: '关闭',
    copySummary: '复制摘要',
    copied: '已复制',
    exitFullscreen: '按 {{key}} 退出全屏模式',
    imageAdjustments: '图片调整',
    brightness: '亮度',
    blur: '模糊',
    selectSceneImage: '选择场景图片',
    pickerDesc: '选择内置样片或上传你自己的照片',
    rename: '重命名',
    delete: '删除',
    renamePhoto: '重命名照片',
    photoName: '照片名称',
    cancel: '取消',
    save: '保存',
    moreActions: '更多操作',
    custom: '自定义',
    customBadge: '自定义',
    uploadImage: '上传图片',
    sessionHistory: '专注历史',
    dayStreak: '连续天数',
    sessions: '次数',
    totalMin: '总分钟',
    noSessions: '暂无记录\n完成一次专注后将显示在此处',
    clearHistory: '清除历史',
    confirmClear: '确定清除所有专注历史？',
    shotBy: '摄影 {{author}}',
    focusedOn: '专注记录 — {{date}}',
  },
  es: {
    name: 'Español',
    deepStill: 'Deep Still',
    tagline1: 'Enfoque profundo, calma profunda.',
    tagline2: 'Un espacio consciente para trabajo ininterrumpido.',
    tagline3: 'Elige tu escena, define tu intención y comienza.',
    beginSession: 'Iniciar sesión',
    clickAnywhere: 'Haz clic para explorar',
    history: 'Historial',
    buyCoffee: 'Invítame un café',
    openingKofi: 'Abriendo Ko-fi...',
    back: 'Atrás',
    chooseScene: 'Elige tu escena',
    sceneDesc: 'Selecciona un ambiente para tu sesión',
    continueWith: 'Continuar con {{name}}',
    parallax: 'Paralaje',
    photographic: 'fotográfico',
    adjust: 'ajustar',
    sessionLength: 'Duración',
    start: 'Iniciar',
    pause: 'Pausar',
    reset: 'Reiniciar',
    newSession: 'Nueva sesión',
    sessionComplete: 'Sesión completa',
    duration: 'Duración',
    scene: 'Escena',
    date: 'Fecha',
    intention: 'Intención',
    intentionPlaceholder: '¿En qué quieres concentrarte?',
    close: 'Cerrar',
    copySummary: 'Copiar resumen',
    copied: 'Copiado',
    exitFullscreen: 'Presiona {{key}} para salir de pantalla completa',
    imageAdjustments: 'Ajustes de imagen',
    brightness: 'Brillo',
    blur: 'Desenfoque',
    selectSceneImage: 'Seleccionar imagen',
    pickerDesc: 'Elige una muestra o sube tu propia foto',
    rename: 'Renombrar',
    delete: 'Eliminar',
    renamePhoto: 'Renombrar foto',
    photoName: 'Nombre de la foto',
    cancel: 'Cancelar',
    save: 'Guardar',
    moreActions: 'Más acciones',
    custom: 'Personalizado',
    customBadge: 'Personal',
    uploadImage: 'Subir imagen',
    sessionHistory: 'Historial de sesiones',
    dayStreak: 'racha de días',
    sessions: 'sesiones',
    totalMin: 'min total',
    noSessions: 'Aún no hay sesiones.\nCompleta una para verla aquí.',
    clearHistory: 'Borrar historial',
    confirmClear: '¿Borrar todo el historial?',
    shotBy: 'foto de {{author}}',
    focusedOn: 'Sesión de enfoque — {{date}}',
  },
  ja: {
    name: '日本語',
    deepStill: 'Deep Still',
    tagline1: '深い集中、深い静けさ。',
    tagline2: '途切れることのない集中のための空間。',
    tagline3: 'シーンを選び、意図を設定し、始めましょう。',
    beginSession: 'セッションを開始',
    clickAnywhere: 'クリックして探索',
    history: '履歴',
    buyCoffee: 'コーヒーをご馳走する',
    openingKofi: 'Ko-fi を開いています...',
    back: '戻る',
    chooseScene: 'シーンを選択',
    sceneDesc: '集中する環境を選んでください',
    continueWith: '{{name}} で続ける',
    parallax: '視差',
    photographic: 'フォト',
    adjust: '調整',
    sessionLength: 'セッション時間',
    start: '開始',
    pause: '一時停止',
    reset: 'リセット',
    newSession: '新規セッション',
    sessionComplete: 'セッション完了',
    duration: '時間',
    scene: 'シーン',
    date: '日付',
    intention: '意図',
    intentionPlaceholder: '何に集中しますか？',
    close: '閉じる',
    copySummary: 'コピー',
    copied: 'コピーしました',
    exitFullscreen: '{{key}} で全画面を終了',
    imageAdjustments: '画像調整',
    brightness: '明るさ',
    blur: 'ぼかし',
    selectSceneImage: '画像を選択',
    pickerDesc: 'サンプルを選ぶか、写真をアップロード',
    rename: '名前変更',
    delete: '削除',
    renamePhoto: '写真の名前を変更',
    photoName: '写真の名前',
    cancel: 'キャンセル',
    save: '保存',
    moreActions: 'その他の操作',
    custom: 'カスタム',
    customBadge: 'カスタム',
    uploadImage: '画像をアップロード',
    sessionHistory: 'セッション履歴',
    dayStreak: '連続日数',
    sessions: 'セッション',
    totalMin: '合計分',
    noSessions: 'まだセッションがありません\nセッションを完了するとここに表示されます',
    clearHistory: '履歴を消去',
    confirmClear: 'すべての履歴を消去しますか？',
    shotBy: '撮影 {{author}}',
    focusedOn: '集中セッション — {{date}}',
  },
  de: {
    name: 'Deutsch',
    deepStill: 'Deep Still',
    tagline1: 'Tiefer Fokus, tiefe Ruhe.',
    tagline2: 'Ein achtsamer Raum für ungestörtes Arbeiten.',
    tagline3: 'Wähle deine Szene, setze deine Absicht und beginne.',
    beginSession: 'Session starten',
    clickAnywhere: 'Klicke zum Erkunden',
    history: 'Verlauf',
    buyCoffee: 'Kauf mir einen Kaffee',
    openingKofi: 'Öffne Ko-fi...',
    back: 'Zurück',
    chooseScene: 'Szene wählen',
    sceneDesc: 'Wähle eine Umgebung für deine Fokussierung',
    continueWith: 'Weiter mit {{name}}',
    parallax: 'Parallaxe',
    photographic: 'fotografisch',
    adjust: 'einstellen',
    sessionLength: 'Sitzungslänge',
    start: 'Starten',
    pause: 'Pause',
    reset: 'Zurücksetzen',
    newSession: 'Neue Sitzung',
    sessionComplete: 'Sitzung beendet',
    duration: 'Dauer',
    scene: 'Szene',
    date: 'Datum',
    intention: 'Absicht',
    intentionPlaceholder: 'Worauf möchtest du dich konzentrieren?',
    close: 'Schließen',
    copySummary: 'Zusammenfassung kopieren',
    copied: 'Kopiert',
    exitFullscreen: 'Drücke {{key}} zum Beenden des Vollbildmodus',
    imageAdjustments: 'Bildanpassungen',
    brightness: 'Helligkeit',
    blur: 'Unschärfe',
    selectSceneImage: 'Bild auswählen',
    pickerDesc: 'Wähle ein Beispiel oder lade ein eigenes Foto hoch',
    rename: 'Umbenennen',
    delete: 'Löschen',
    renamePhoto: 'Foto umbenennen',
    photoName: 'Foto-Name',
    cancel: 'Abbrechen',
    save: 'Speichern',
    moreActions: 'Weitere Aktionen',
    custom: 'Benutzerdefiniert',
    customBadge: 'Eigenes',
    uploadImage: 'Bild hochladen',
    sessionHistory: 'Sitzungsverlauf',
    dayStreak: 'Tage Serie',
    sessions: 'Sitzungen',
    totalMin: 'Min gesamt',
    noSessions: 'Noch keine Sitzungen.\nSchließe eine ab, um sie hier zu sehen.',
    clearHistory: 'Verlauf löschen',
    confirmClear: 'Gesamten Verlauf löschen?',
    shotBy: 'fotografiert von {{author}}',
    focusedOn: 'Fokus-Sitzung — {{date}}',
  },
  ru: {
    name: 'Русский',
    deepStill: 'Deep Still',
    tagline1: 'Глубокий фокус, глубокое спокойствие.',
    tagline2: 'Осознанное пространство для непрерывной работы.',
    tagline3: 'Выберите сцену, задайте намерение и начните.',
    beginSession: 'Начать сессию',
    clickAnywhere: 'Нажмите, чтобы исследовать',
    history: 'История',
    buyCoffee: 'Угости меня кофе',
    openingKofi: 'Открываю Ko-fi...',
    back: 'Назад',
    chooseScene: 'Выберите сцену',
    sceneDesc: 'Выберите обстановку для концентрации',
    continueWith: 'Продолжить с {{name}}',
    parallax: 'Параллакс',
    photographic: 'фото',
    adjust: 'настройки',
    sessionLength: 'Длительность',
    start: 'Старт',
    pause: 'Пауза',
    reset: 'Сброс',
    newSession: 'Новая сессия',
    sessionComplete: 'Сессия завершена',
    duration: 'Длительность',
    scene: 'Сцена',
    date: 'Дата',
    intention: 'Намерение',
    intentionPlaceholder: 'На чем вы хотите сосредоточиться?',
    close: 'Закрыть',
    copySummary: 'Копировать',
    copied: 'Скопировано',
    exitFullscreen: 'Нажмите {{key}} для выхода из полноэкранного режима',
    imageAdjustments: 'Настройки изображения',
    brightness: 'Яркость',
    blur: 'Размытие',
    selectSceneImage: 'Выберите изображение',
    pickerDesc: 'Выберите образец или загрузите своё фото',
    rename: 'Переименовать',
    delete: 'Удалить',
    renamePhoto: 'Переименовать фото',
    photoName: 'Название фото',
    cancel: 'Отмена',
    save: 'Сохранить',
    moreActions: 'Другие действия',
    custom: 'Пользовательский',
    customBadge: 'Своё',
    uploadImage: 'Загрузить изображение',
    sessionHistory: 'История сессий',
    dayStreak: 'дней подряд',
    sessions: 'сессии',
    totalMin: 'всего мин',
    noSessions: 'Пока нет сессий.\nЗавершите одну, чтобы увидеть её здесь.',
    clearHistory: 'Очистить историю',
    confirmClear: 'Очистить всю историю?',
    shotBy: 'фото {{author}}',
    focusedOn: 'Сессия фокуса — {{date}}',
  },
}
